// @ts-nocheck
import backOrdersReducer, { BackOrdersActions } from "@store/Framework/Store/Store/Data/BackOrders/BackOrdersReducer";
import { combineReducers } from "redux";

const dataReducers = {
    backOrders: backOrdersReducer,
};

export type StoreDataActions = BackOrdersActions;
export default combineReducers(dataReducers);
